<template>
  <!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In  -->
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    width="50px" height="50px" viewBox="0 0 623.28 595.44" style="enable-background:new 0 0 623.28 595.44;"
    xml:space="preserve">
  <g>
    <g>
      <polygon points="415.52,297.7 363.57,207.76 363.56,207.76 363.55,207.75 273.24,207.77 325.2,297.74 273.29,387.69 
        363.59,387.67 363.59,387.67 415.51,297.71 415.51,297.71 		"/>
    </g>
    <g>
      <polygon points="259.73,387.69 311.65,297.74 259.69,207.78 259.67,207.78 207.75,297.75 207.76,297.76 259.71,387.7 		"/>
    </g>
    <g>
      <polygon points="142.23,207.76 51.92,207.78 51.92,207.78 0,297.74 0,297.75 0,297.76 51.95,387.69 51.96,387.69 51.96,387.7 
        142.28,387.68 90.31,297.72 		"/>
    </g>
    <g>
      <polygon points="207.75,297.7 155.8,207.76 155.78,207.76 103.87,297.72 155.83,387.67 155.84,387.67 207.76,297.71 		"/>
    </g>
    <g>
      <polygon points="557.74,207.76 467.44,207.78 467.44,207.78 415.52,297.74 415.52,297.75 415.52,297.76 467.46,387.69 
        467.47,387.69 467.48,387.7 557.79,387.68 505.83,297.72 		"/>
    </g>
    <g>
      <polygon points="623.27,297.7 571.32,207.76 571.3,207.76 519.39,297.72 571.34,387.67 571.36,387.67 623.28,297.71 		"/>
    </g>
    <g>
      <polygon points="299.89,394.46 221.67,439.63 221.67,543.51 311.63,595.44 311.64,595.44 389.85,550.29 299.89,498.36 		"/>
    </g>
    <g>
      <polygon points="311.63,387.7 311.63,491.58 401.58,543.51 401.6,543.51 401.6,439.63 311.65,387.69 		"/>
    </g>
    <g>
      <polygon points="401.59,344.89 401.6,344.88 401.6,344.88 401.59,344.88 		"/>
    </g>
    <g>
      <polygon points="401.59,241.01 401.6,241.02 401.6,241 401.59,241 		"/>
    </g>
    <g>
      <polygon points="311.65,207.75 389.85,162.6 299.9,110.66 299.9,6.78 221.68,51.93 221.68,155.81 311.64,207.75 		"/>
    </g>
    <g>
      <polygon points="401.59,155.81 401.6,155.81 401.6,137.13 401.6,137.13 401.6,51.93 311.65,0 311.64,0.01 311.64,103.89 
        401.59,155.82 		"/>
    </g>
  </g>
  </svg>
</template>

<script>
export default {
  name: "ittention"
};
</script>
